var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logs-container"},[_c('div',{ref:"wrapper",staticClass:"wrapper"},[_c('div',{ref:"marquee",staticStyle:{"text-align":"left","width":"2000px"}},[_c('span',{ref:"marqueeContent"},[_vm._v(_vm._s(_vm.info))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }